import React, { useState } from 'react'
import { FC } from 'react'
import { DayOfWeekEnum, ProfessionalAvailability } from '../../../models'
import { Collapse, ListGroup, ListGroupItem } from 'reactstrap'
import { DateField, TimeIntervalField } from '../fields'
import { useTranslations } from '../../../store/translations/hooks'
import { TK } from '../../../store/translations/translationKeys'
import Typography from '../../Typography'
import RemoveIcon from '@material-ui/icons/Delete'
import CheckIcon from '@material-ui/icons/Check'
import AddCircleIcon from '@material-ui/icons/AddCircleRounded';
import { IconButton } from '@mui/material'
import AppButton from '../../AppButton'

export const AvailabilityField: FC<{
  id: string,
  label?: string,
  values: ProfessionalAvailability[],
  onChange: (values: ProfessionalAvailability[]) => void,
}> = ({id, label, values, onChange}) => {

  const t = useTranslations()
  const [selected, setSelected] = useState<number|undefined>(undefined)

  const handleAddClick = () => {
    onChange([{
      from: new Date().toISOString().substring(0, 10),
      timeSlots: values[0]?.timeSlots ?? [
        {dayOfWeek: DayOfWeekEnum.Monday, start: '08:00', end: '20:00'},
      ],
    }, ...values])
    setSelected(0)
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XS)'}}>
      {label && <label style={{ fontSize: '0.875rem', marginBottom: '8px', display: 'block', fontWeight: 500 }}>{label}</label>}
      <ListGroup>
        {values.map((availability, idx) => (
          <ListGroupItem key={idx}>
            {selected !== idx 
              ? <AppButton color='link' onClick={() => setSelected(idx)} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer'}}>
                  <span><b>{t(TK.since)}</b> {availability.from}</span>
                </AppButton>
              : <>
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 'var(--spacer-XS)', width: '100%'}}>
                  <AppButton
                    color='link'
                    style={{flex: '1 1 18rem', minWidth: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                    onClick={e => e.stopPropagation()}
                  >
                    <Typography style={{minWidth: '6rem', cursor: 'pointer'}} onClick={() => setSelected(undefined)}><b>{t(TK.since)}</b></Typography>
                    &nbsp;
                    <DateField
                      id={`${id}-from`}
                      type='date'
                      value={availability.from}
                      onChange={from => onChange(values.map((v, i) => i !== idx ? v : {...v, from}))}
                    />
                  </AppButton>
                  <div style={{display: 'flex', gap: 'var(--spacer-XS)', marginLeft: 'auto'}}>
                    <AppButton outline color='success' onClick={() => setSelected(undefined)}><CheckIcon/></AppButton>
                    <AppButton outline color='danger' onClick={() => onChange(values.filter((_, i) => i !== idx))}><RemoveIcon/></AppButton>
                  </div>
                </div>
              </>
            }
            <Collapse isOpen={selected === idx}>
              <hr/>
              <TimeIntervalField 
                id={`${id}-${availability.from}-time-slots`}
                values={availability.timeSlots || []}
                onChange={timeSlots => onChange(values.map((v, i) => i !== idx ? v : {...v, timeSlots}))}
              />
            </Collapse>
          </ListGroupItem>)
        )}

          <div style={{width: '100%', justifyContent: 'center', textAlign: 'center', marginTop: 'var(--spacer-S)'}}>
            <IconButton id={'add-service-button'} onClick={handleAddClick} size="small">
                <AddCircleIcon />
            </IconButton>
            <span style={{verticalAlign: 'text-top', cursor: 'pointer'}} onClick={handleAddClick}>{t(TK.add)}</span>
        </div>
      </ListGroup>
    </div>
  )
}
